module.exports = __webpack_public_path__ + "img/Dantam Hair 36.9bc43d4f.jpg";